import React from 'react';
import {Navigate, Outlet, useLocation} from 'react-router-dom';
import {useContext} from '../../../contexts/Context';
import LoadingSpinner from '../../common/LoadingSpinner';

const FirstInstanceGuard: React.FC = () => {
    const {isAdminExists, isAdminLoading} = useContext()
    const location = useLocation();

    if (isAdminLoading) {
        return <LoadingSpinner/>;
    }

    return isAdminExists ? (
        <Outlet/>
    ) : (
        <Navigate to="/register-admin" replace state={{from: location}}/>
    );
};

export default FirstInstanceGuard;
